import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import { AuthUser, setAuthState } from "state/authSlice";
import { useEffect } from "react";


const useAuthListener = () => {
  const {
    isAuthenticated,
    isLoading,
    user,
    getAccessTokenSilently,
    loginWithRedirect,
  } = useAuth0();
  const dispatch = useDispatch();
  // const token = getAccessTokenSilently();
  useEffect(() => {
    const fetchToken = async () => {
      if (isAuthenticated) {
        try {
          const token = await getAccessTokenSilently();
          // console.log("user:",user);
          const authUser: AuthUser = {
            name: user?.name as string,
            email: user?.email as string,
            picture: user?.picture as string,
            nickname: user?.nickname as string,
            school_id: user?.school_id as number,
            school_name: user?.school_name as string,
            id: 0,
            isAdmin: user?.isAdmin as boolean,
          };
          dispatch(
            setAuthState({ isAuthenticated, isLoading, user: authUser, token })
          );
        } catch (error) {
          console.error("Failed to get token", error);
        }
      } else {
        if (!isLoading) {
          loginWithRedirect();
        }
        dispatch(
          setAuthState({ isAuthenticated, isLoading, user, token: null })
        );
      }
    };

    fetchToken();
  }, [
    isAuthenticated,
    isLoading,
    user,
    getAccessTokenSilently,
    dispatch,
    loginWithRedirect,
  ]);
};

export default useAuthListener;
